import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/leave-application-admin?${params}`);
  },
  getById(id) {
    return api.get(`/api/v1/leave-application/${id}`);
  },
  update(id, data) {
    return api.put(`/api/v1/leave-application/${id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/leave-application`, data);
  },
  deleteForAdmin(id) {
    return api.delete(`/api/v1/leave-application/${id}`);
  },
  deleteForAll(id) {
    return api.delete(`/api/v1/leave-application-delete/${id}`);
  },
  changeLeaveStatus(data) {
    return api.put(`/api/v1/leave-application-activation`, data);
  },
  changeLeaveStatusForChecked(data) {
    return api.put(`/api/v1/leave-application-multi-active`, data);
  },
  category() {
    return api.get(`/api/v1/leave-category`);
  },
};
